module.exports = __webpack_public_path__ + "static/media/workers.3bb77abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/style/images/workers.png
// module id = 2540
// module chunks = 110